"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = exports["default"] = void 0;
var _default = {};
exports["default"] = _default;
var sizes = {
  'x-small': 1,
  small: 2,
  normal: 3,
  large: 4,
  'x-large': 5
};
exports.sizes = sizes;